import { PlayIcon } from '@heroicons/react/24/solid';
import { Box, Card, Skeleton } from '@mui/material';

function VideoCardSkeleton() {
  return (
    <Card
      sx={{
        position: 'relative',
        boxShadow: 3,
        borderRadius: 3,
        bgcolor: 'background.paper',
        p: 0,
        m: 0,
      }}
    >
      <Skeleton variant="rectangular" height={200} sx={{ m: 1 }} />
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1,
        }}
      >
        <PlayIcon className="h-16 w-16 text-[#B5B6C8B2]" />
      </Box>
    </Card>
  );
}

export default VideoCardSkeleton;
